/* global Dropdown, queryClass */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, QUERY_KEYS } from '../queryClient';

// Config
import { crudConfig } from '../../../conf/criteria';

export const getQueryKey = getQueryKeyBase.bind(null, QUERY_KEYS.CRITERIA_METADATA);

export const useGetCriteriaMetadata = (sessionToken) => {
    const Client = apiClient(crudConfig.metadata);
    const query = useQuery({
        queryKey: getQueryKey(),
        queryFn: async () => {
            const config = await Client.fetch(sessionToken);

            if (!config) return {};
            const filterMap = new Map();
            const propertyMap = new Map();
            propertyMap.set(queryClass, 'FindAll');
            const criteriaTypeDTOOptions = await (() =>
                new Promise((resolve) => {
                    Dropdown.getList(
                        config.fieldMap.criteriaTypeDTO.referenceResourcePlugin,
                        config.fieldMap.criteriaTypeDTO.referenceResourceName,
                        filterMap,
                        undefined,
                        propertyMap,
                        function(data, jqxhr) {
                            resolve(data);
                        }
                    );
                }))();

            return {
                enums: {
                    method: config?.fieldMap?.method?.enum?.enumMap ?? {},
                    criteriaType: (criteriaTypeDTOOptions ?? [])
                        .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
                        .reduce((acc, curr) => {
                            return {
                                ...acc,
                                [curr.criteriaTypeId]: curr.name
                            };
                        }, {})
                },
                options: {
                    criteriaType: criteriaTypeDTOOptions
                }
            };
        },
        onSuccess: (data) => {},
        onError: (data) => {
            console.log('Error', data);
        },
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });

    return {
        data: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
        refetch: async () => {
            await query.refetch();
        }
    };
};
